import _ from 'lodash';
import { Parser as parser } from 'expr-eval';

const findValue = (data, id, seriesName, category) => {
  // поиск нужного графика
  const chartData = data[id];
  // поиск нужной серии в данных графика, если серия не найдена вернет 0
  const chartSeries = chartData.series[seriesName];
  if (!chartSeries) {
    return 0;
  }

  return chartSeries.data[category] ? chartSeries.data[category] : 0;
};

const getUniqSeries = (data) =>
  data.reduce((res, val) => {
    const seriesSet = new Set(res);
    val.series.forEach((s) => {
      seriesSet.add(s.name);
    });
    return Array.from(seriesSet);
  }, []);

const getFormulaSeries = (data, uniqSeries, categories, expr) =>
  uniqSeries.map((s, i) => {
    let dataSum = 0;
    return {
      name: s,
      id: i,
      parentId: 'Formula',
      data: categories.map((category) => {
        // объект который нужен для вычисления формулы
        const exprObj = expr.variables().reduce(
          (res, variable) => ({
            ...res,
            [variable]: findValue(data, variable, s, category),
          }),
          {}
        );
        const evaluatedVal = expr.evaluate(exprObj);
        // eslint-disable-next-line no-restricted-globals
        const value = !isFinite(evaluatedVal) ? 0 : evaluatedVal;
        dataSum += value;

        return [category, value];
      }),
      dataSum,
    };
  });

// создает объект из массива [{...,name:'example',}]=>{'example':{}}
const nameBySeries = (series) => {
  const seriesObj = {};
  for (let i = 0; i < series.length; i++) {
    seriesObj[String(series[i].name)] = {
      ...series[i],
      data: Object.fromEntries(series[i].data),
    };
  }
  return seriesObj;
};

// создает объект из массива [{...,id:1,}]=>{1:{}}
const idByData = (data) => {
  const dataObj = {};
  for (let i = 0; i < data.length; i++) {
    dataObj[data[i].id] = {
      ...data[i],
      series: nameBySeries(data[i].series, 'name'),
    };
  }
  return dataObj;
};

const calcFormula = (data, enteredFormula, isFormulaOnly) => {
  const expr = parser.parse(enteredFormula);
  const uniqSeries = getUniqSeries(data);
  const filteredData = data.filter((d) => expr.variables().includes(d.id));
  const categories = Array.from(new Set(filteredData.flatMap((chartData) => chartData.categories)));
  // этот объект создан для оптимизации, чтобы по ключу можно было быстро доставать нужный нам ивент, а в ивенте
  // нужную серию.
  const transformedData = idByData(data);
  const formulaSeries = getFormulaSeries(transformedData, uniqSeries, categories, expr);

  return !isFormulaOnly
    ? data.concat([
        {
          categories,
          id: 'Formula',
          name: enteredFormula,
          series: formulaSeries,
          isSplitBy: data[0]?.isSplitBy,
          timeUnit: _.get(data, [0, 'info', 'groupBy']),
        },
      ])
    : [
        {
          categories,
          id: 'Formula',
          name: enteredFormula,
          series: formulaSeries,
          isSplitBy: data[0]?.isSplitBy,
          timeUnit: _.get(data, [0, 'info', 'groupBy']),
        },
      ];
};

export default calcFormula;
